import React from 'react';

/* Ícones SVG inline da home pública (mesmos paths do layout aprovado). */

interface IconProps {
	className?: string;
	stroke?: string;
	size?: number;
}

export const ArrowIcon: React.FC<IconProps> = ({ className = 'cr-arrow', stroke = 'currentColor' }) => (
	<svg
		className={className}
		viewBox='0 0 24 24'
		fill='none'
		stroke={stroke}
		strokeWidth='2.2'
		strokeLinecap='round'
		strokeLinejoin='round'
		aria-hidden='true'
	>
		<path d='M5 12h14M13 6l6 6-6 6' />
	</svg>
);

const WA_PATH =
	'M16 3C8.8 3 3 8.7 3 15.8c0 2.5.7 4.9 2 7L3 29l6.4-2a13.2 13.2 0 0 0 6.6 1.8c7.2 0 13-5.7 13-12.9S23.2 3 16 3zm0 23.6c-2.1 0-4.1-.6-5.8-1.6l-.4-.2-3.8 1.2 1.2-3.6-.3-.4A10.5 10.5 0 0 1 5.2 15.8C5.2 9.9 10 5.2 16 5.2s10.8 4.7 10.8 10.6S22 26.6 16 26.6zm5.9-7.9c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2l-1 1.2c-.2.2-.4.2-.7.1a8.8 8.8 0 0 1-4.4-3.8c-.3-.6.3-.5.9-1.7.1-.2 0-.4 0-.6l-1-2.4c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.3 1.4 3.5c.2.2 2.4 3.6 5.8 5 2.2.9 3 1 4 .8.7-.1 1.9-.8 2.2-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z';

export const WhatsAppIcon: React.FC<{ fill?: string }> = ({ fill = '#FFFFFF' }) => (
	<svg viewBox='0 0 32 32' aria-hidden='true'>
		<path fill={fill} d={WA_PATH} />
	</svg>
);

/** Versão simplificada (sem o telefone interno) usada no rodapé. */
export const WhatsAppOutlineIcon: React.FC = () => (
	<svg viewBox='0 0 32 32' fill='currentColor' aria-hidden='true'>
		<path d='M16 3C8.8 3 3 8.7 3 15.8c0 2.5.7 4.9 2 7L3 29l6.4-2a13.2 13.2 0 0 0 6.6 1.8c7.2 0 13-5.7 13-12.9S23.2 3 16 3zm0 23.6c-2.1 0-4.1-.6-5.8-1.6l-.4-.2-3.8 1.2 1.2-3.6-.3-.4A10.5 10.5 0 0 1 5.2 15.8C5.2 9.9 10 5.2 16 5.2s10.8 4.7 10.8 10.6S22 26.6 16 26.6z' />
	</svg>
);

export const WhatsAppDot: React.FC = () => (
	<i className='cr-wa-dot'>
		<WhatsAppIcon />
	</i>
);

export const PhoneIcon: React.FC = () => (
	<svg
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
		aria-hidden='true'
	>
		<path d='M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.9 2z' />
	</svg>
);

export const EyeIcon: React.FC<{ off?: boolean }> = ({ off = false }) => (
	<svg
		width='18'
		height='18'
		viewBox='0 0 24 24'
		fill='none'
		stroke='#141414'
		strokeWidth='1.8'
		strokeLinecap='round'
		strokeLinejoin='round'
		aria-hidden='true'
	>
		<path d='M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z' />
		<circle cx='12' cy='12' r='3' />
		{off && <path d='M4 4l16 16' />}
	</svg>
);

export const MenuIcon: React.FC = () => (
	<svg
		width='22'
		height='22'
		viewBox='0 0 24 24'
		fill='none'
		stroke='#141414'
		strokeWidth='2'
		strokeLinecap='round'
		aria-hidden='true'
	>
		<path d='M4 7h16M4 12h16M4 17h16' />
	</svg>
);

export const CloseIcon: React.FC<{ size?: number }> = ({ size = 16 }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		fill='none'
		stroke='#141414'
		strokeWidth='2'
		strokeLinecap='round'
		aria-hidden='true'
	>
		<path d='M6 6l12 12M18 6 6 18' />
	</svg>
);

const valueIconProps = {
	viewBox: '0 0 24 24',
	fill: 'none',
	strokeWidth: 1.6,
	strokeLinecap: 'round' as const,
	strokeLinejoin: 'round' as const,
	'aria-hidden': true,
};

export const MarketIcon: React.FC<{ stroke: string }> = ({ stroke }) => (
	<svg {...valueIconProps} stroke={stroke}>
		<path d='M4 20V11M10 20V5M16 20v-7M22 20H2' />
	</svg>
);

export const ConnectionsIcon: React.FC<{ stroke: string }> = ({ stroke }) => (
	<svg {...valueIconProps} stroke={stroke}>
		<circle cx='12' cy='8' r='3.5' />
		<path d='M5 20a7 7 0 0 1 14 0' />
		<circle cx='4.5' cy='10' r='2' />
		<circle cx='19.5' cy='10' r='2' />
	</svg>
);

export const ShieldIcon: React.FC<{ stroke: string }> = ({ stroke }) => (
	<svg {...valueIconProps} stroke={stroke}>
		<path d='M12 2 4 6v6c0 5 3.5 9 8 10 4.5-1 8-5 8-10V6z' />
		<path d='m9 12 2 2 4-4' />
	</svg>
);
